import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import Avatar from 'components/common/Avatar';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import TableRowAction from 'components/common/TableRowAction';
import { ToDoListItem } from 'components/we-raise-common/ToDoList';
import {
  weDonorCommunicationData,
  weRelationManagementData,
  weTaskList,
  weUserImage
} from 'data/weraise-data/donar-data';
import React, { useState } from 'react';
import { Card, Col, ProgressBar, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const topDonationData = [
  { id: 1, title: 'Bread 4 Yemen', value: '$850.00', color: 'text-primary' },
  {
    id: 2,
    title: 'Build Orphanage Centre',
    value: '$550.00',
    color: 'text-secondary'
  },
  { id: 3, title: 'Water Relief', value: '$150.00', color: 'text-info' }
];

const DonorRelationManagement = () => {
  const [todoItems, setTodoItems] = useState(weTaskList);
  const handleChange = (id, completed) => {
    const updatedTodos = todoItems.map(item =>
      item.id === id ? { ...item, completed } : item
    );
    setTodoItems(updatedTodos);
  };

  const columns = [
    {
      accessor: 'reporter',
      Header: 'reporter',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'date',
      Header: 'Date',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'description',
      Header: 'Description',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => (
        <p className="text-truncate mb-0" style={{ maxWidth: '400px' }}>
          {rowData.row.original.description}
        </p>
      )
    },
    {
      accessor: 'id',
      Header: '',
      cellProps: {
        className: 'py-2 text-end'
      },
      disableSortBy: true,

      Cell: rowData => {
        const { id } = rowData.row;
        return (
          <TableRowAction
            onCLickEdit={() => console.log(id)}
            onCLickDelete={() => console.log(id)}
          />
        );
      }
    }
  ];

  return (
    <>
      <Card className="mb-3">
        <FalconCardHeader
          title={<h4 className="mt-2 fw-bold">Relation Management</h4>}
          light={false}
          titleTag="div"
          menuClassName="align-items-center"
          endEl={
            <IconButton icon="plus" transform="shrink-3">
              <span className="d-none d-md-inline-block ms-2">
                Add Donation
              </span>
            </IconButton>
          }
        />
      </Card>
      <Row className="g-3 mb-3">
        <Col xs={12}>
          <Card className="h-100">
            <FalconCardHeader
              title={
                <>
                  <h5 className="text-primary">
                    Welcome to Contact Relation management center!
                  </h5>
                  <h6 className="text-600">
                    Here are some quick links for you to start
                  </h6>
                </>
              }
              titleTag="div"
              className="pb-1"
              // menuClassName="align-items-start"
              // endEl={<CardDropdown />}
            />

            <Card.Body className="z-index-1">
              <Row className="g-2 h-100 align-items-end">
                {weDonorCommunicationData.map(
                  ({ icon, color, title, text }) => {
                    return (
                      <Col sm={6} md={4} key={title}>
                        <Flex className="position-relative mb-2">
                          <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2">
                            <FontAwesomeIcon
                              icon={icon}
                              className={`text-${color}`}
                            />
                          </div>
                          <div className="flex-1">
                            <Link to="#!" className="stretched-link text-800">
                              <h6 className="mb-0">{title}</h6>
                            </Link>
                            <p className="mb-0 fs--2 text-500 ">{text}</p>
                          </div>
                        </Flex>
                      </Col>
                    );
                  }
                )}
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="g-3 mb-3">
        <Col md={7}>
          <Card>
            <FalconCardHeader
              title={'Assigned Staff'}
              light={false}
              titleTag="div"
              className="pb-0"
              menuClassName="align-items-start"
              endEl={
                <IconButton
                  icon="pen"
                  variant="falcon-default"
                  className="fs--1 bg-transparent shadow-none p-0"
                />
              }
            />
            <Card.Body>
              <Flex alignItems={'center'}>
                <Avatar src={weUserImage} size="2xl" />

                <div className="ms-2">
                  <p className="mb-0 fw-medium">Ibrahim Amir</p>
                  <p className="mb-0 fw-medium fs--2 text-500">
                    CRM Specialist
                  </p>
                </div>
              </Flex>
              <hr />
              <Flex justifyContent={'between'}>
                <p className="mb-2 fw-medium">
                  Targeted Donation <FontAwesomeIcon icon={'question-circle'} />
                </p>
                <IconButton
                  icon="pen"
                  variant="falcon-default"
                  className="fs--1 bg-transparent shadow-none p-0"
                />
              </Flex>
              <p className="text-success fs-2 fw-medium">
                $1500.00 <span className="fs--1 text-700">/ $ 2,500.00</span>
              </p>

              <ProgressBar
                now={60}
                style={{ height: '5px', marginBottom: '1.5rem' }}
              />
              <hr />
              <div>
                <Flex justifyContent={'between'}>
                  <p className="mb-2 fa--2 fw-medium">Top Donations to date</p>
                  <p className="mb-2 fs--2 fw-medium">Amount</p>
                </Flex>
                {topDonationData.map((item, index) => (
                  <div
                    key={item.id}
                    className={classNames(
                      'p-3 border rounded-3 bg-soft-primary',
                      { 'mb-3': index != topDonationData.length - 1 }
                    )}
                  >
                    <Flex justifyContent={'between'} alignItems={'center'}>
                      <p className="mb-0 text-900 fw-medium">
                        <FontAwesomeIcon
                          icon={'circle'}
                          className={classNames('me-2', item.color)}
                        />
                        {item.title}
                      </p>
                      <p className="mb-0 fs--2 text-600 fw-medium">
                        {item.value}
                      </p>
                    </Flex>
                  </div>
                ))}
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={5}>
          <Card>
            <FalconCardHeader title="Tasks" titleTag="h6" />
            <Card.Body className="p-0 overflow-hidden">
              {todoItems.map((item, index) => (
                <ToDoListItem
                  key={item.id}
                  item={item}
                  index={index}
                  length={todoItems.length}
                  setTodoItems={setTodoItems}
                  handleChange={handleChange}
                />
              ))}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col md={12} xxl={12} className="h-md-100">
          <CustomAdvanceTable
            data={weRelationManagementData}
            columns={columns}
            title="Comments"
            showSearchInput
            searchInputPlaceHolder="Search"
            addNew={false}
            perPage={10}
          />
        </Col>
      </Row>
    </>
  );
};

export default DonorRelationManagement;
